export default __webpack_public_path__ + "static/media/close.fa6ccfae.svg";